<template>
  <WidgetPanel v-if="display">
    <template #header>
      <div class="flex justify-between">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Vollständige Einrichtung
        </h3>
        <button @click="onComplete">
          <XMarkIcon class="flex-shrink-0 h-5 w-5 text-gray-400" />
        </button>
      </div>
    </template>
    <template #default>
      <ul role="list" class="list-items">
        <SetupWidgetItem
          as="li"
          title="Wachstumsziele festlegen"
          text="Priorisiere die nächsten Ziele mit deinem Podcast"
          route="podcast.edit.objective"
          color="bg-cyan-950"
          icon="StarIcon"
          :setup="podcast.setup_objective"
        />
        <SetupWidgetItem
          as="li"
          title="Empfehlungen personalisieren"
          text="Passe Methodentipps an deine Wachstumsphase an"
          route="podcast.edit.stage"
          color="bg-cyan-950"
          icon="AdjustmentsVerticalIcon"
          :setup="podcast.setup_stage"
        />
        <SetupWidgetItem
          as="li"
          title="Strategie definieren"
          text="Beantworte die Top-7 Aspekte deines Podcast"
          route="podcast.edit.strategy"
          color="bg-cyan-950"
          icon="LightBulbIcon"
          :setup="podcast.setup_strategy"
        />
        <SetupWidgetItem
          as="li"
          title="Erfolgskriterien auswählen"
          text="Lege Metriken fest, die du im Blick behalten möchtest"
          route="podcast.edit.metrics"
          color="bg-cyan-950"
          icon="ArrowUpRightIcon"
          :setup="podcast.setup_metrics"
        />
        <SetupWidgetItem
          as="li"
          title="Meilensteine festlegen"
          text="Bestimme Zielwerte, auf die du hinarbeiten möchtest"
          route="podcast.edit.milestones"
          color="bg-cyan-950"
          icon="FlagIcon"
          :setup="podcast.setup_milestones"
        />
        <SetupWidgetItem
          as="li"
          title="Coworker*innen einladen"
          text="Füge beliebig viele Menschen zu deinem Podcast-Team hinzu"
          route="podcast.edit.coworkers"
          color="bg-cyan-950"
          icon="UsersIcon"
          :setup="podcast.setup_coworkers"
        />
      </ul>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useProcessResource } from '@/client/actions';

const props = defineProps({podcast: Object});
const store = useStore();

const setup = computed(() => props.podcast.setup);
const complete = computed(() => props.podcast.completed);
const display = computed(() => ! (setup.value || complete.value));

const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + ':complete');

const { process, processing } = useProcessResource(target);

const onSuccess = () => store.dispatch('context/refresh', parent.value);
const onComplete = () => process(onSuccess);
</script>

<style scoped>
.headline
{
  @apply leading-6 font-medium;
  @apply text-lg text-gray-900;
}

.list-items
{
  @apply grid grid-cols-1 gap-6 sm:grid-cols-2;
  @apply my-6 mx-6;
}
</style>
